import { ScrollReveal } from '@/components/ui/scroll-reveal';

const TESTIMONIALS = [
  {
    name: 'Dan the Man!!!',
    city: 'Orlando · Thumbtack',
    rating: 5,
    quote: 'Showed up on time, did exactly what he said, and left the place shining. Already booked again.',
  },
  {
    name: 'They are the best, hands down.',
    city: 'Winter Park · Thumbtack',
    rating: 5,
    quote: 'The attention to detail is on another level. Our office has never looked this good.',
  },
  {
    name: 'Easiest 5-stars I\'ve given.',
    city: 'Altamonte Springs',
    rating: 5,
    quote: 'Post-construction mess I thought was unsalvageable. They made it showroom-ready. Unreal work.',
  },
];

export function Testimonials() {
  return (
    <section className="relative py-28 bg-charcoal overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <ScrollReveal className="text-center mb-16">
          <div className="inline-flex items-center gap-3 mb-4">
            <span className="h-[2px] w-10 bg-thunder" />
            <span className="text-thunder font-display tracking-[0.4em] text-xs">// VERIFIED REVIEWS</span>
            <span className="h-[2px] w-10 bg-thunder" />
          </div>
          <h2 className="font-display font-bold text-white text-5xl sm:text-6xl lg:text-7xl leading-[0.9]">
            THE <span className="text-thunder">VERDICT</span>
          </h2>
        </ScrollReveal>

        <div className="grid md:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <ScrollReveal key={i} delay={i * 80}>
              <div className="bg-charcoal-deep border-t-4 border-thunder p-8 relative hover:-translate-y-2 transition-transform duration-300 h-full">
                <div className="absolute -top-5 left-8 bg-charcoal-deep px-3 font-display text-electric text-xs tracking-[0.3em]">
                  REVIEW 0{i + 1}
                </div>
                <div className="text-thunder text-2xl mb-6">{'★'.repeat(t.rating)}</div>
                <p className="text-white text-xl leading-snug mb-8 font-display font-medium">
                  &ldquo;{t.quote}&rdquo;
                </p>
                <div className="pt-5 border-t border-white/10">
                  <div className="font-display font-bold text-white tracking-wider">{t.name}</div>
                  <div className="text-white/50 text-xs tracking-[0.2em] uppercase mt-1">{t.city}</div>
                </div>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}
